import React from 'react';
import { connect } from 'react-redux';
import { PatientCareCenterNoteSection } from 'PatientCareCenter/Note';
import styles from './Common.module.css'
import { DBCheckBoxComment } from '_components'

class PatientCareCenterNoteObjectiveObsGaitPeds extends React.Component {

    render() {
       
            return (
                <PatientCareCenterNoteSection id='obj_obs_gaitpeds' name='Gait' level={2} noChildPadding={true}>
                    <div className={styles.form_row}>
                      <div className={styles.gap}>
                        <DBCheckBoxComment
                         noteId={this.props.noteId}
                         entity='PTOBJECTIVEPEDS'
                         entityKeyColumn='OPNO'
                         entityKeyValue={this.props.opno}
                         field= 'OPGAWNL'
                         className={styles.checkbox}
                         label='WNL'
                         textAreaStyle={styles.formTextArea}
                       />
                    </div>
                  </div>

                  <div className={styles.form_row}>
                      <div className={styles.gap}>
                        <DBCheckBoxComment
                         noteId={this.props.noteId}
                         entity='PTOBJECTIVEPEDS'
                         entityKeyColumn='OPNO'
                         entityKeyValue={this.props.opno}
                         field= 'OPGAANTALGIC'
                         className={styles.checkbox}
                         label='Antalgic'
                         textAreaStyle={styles.formTextArea}
                       />
                    </div>
                  </div>


                  <div className={styles.form_row}>
                      <div className={styles.gap}>
                        <DBCheckBoxComment
                         noteId={this.props.noteId}
                         entity='PTOBJECTIVEPEDS'
                         entityKeyColumn='OPNO'
                         entityKeyValue={this.props.opno}
                         field= 'OPGANOARM'
                         className={styles.checkbox}
                         label='No arm swing'
                         textAreaStyle={styles.formTextArea}
                       />
                    </div>
                  </div>


                  <div className={styles.form_row}>
                      <div className={styles.gap}>
                        <DBCheckBoxComment
                         noteId={this.props.noteId}
                         entity='PTOBJECTIVEPEDS'
                         entityKeyColumn='OPNO'
                         entityKeyValue={this.props.opno}
                         field= 'OPGANOHEEL'
                         className={styles.checkbox}
                         label='No heel strike'
                         textAreaStyle={styles.formTextArea}
                       />
                    </div>
                  </div>

                  <div className={styles.form_row}>
                      <div className={styles.gap}>
                        <DBCheckBoxComment
                         noteId={this.props.noteId}
                         entity='PTOBJECTIVEPEDS'
                         entityKeyColumn='OPNO'
                         entityKeyValue={this.props.opno}
                         field= 'OPGATOEWALK'
                         className={styles.checkbox}
                         label='Toe walking'
                         textAreaStyle={styles.formTextArea}
                       />
                    </div>
                  </div>

                  <div className={styles.form_row}>
                      <div className={styles.gap}>
                        <DBCheckBoxComment
                         noteId={this.props.noteId}
                         entity='PTOBJECTIVEPEDS'
                         entityKeyColumn='OPNO'
                         entityKeyValue={this.props.opno}
                         field= 'OPGACROUCH'
                         className={styles.checkbox}
                         label='Crouch'
                         textAreaStyle={styles.formTextArea}
                       />
                    </div>
                  </div>

                  <div className={styles.form_row}>
                      <div className={styles.gap}>
                        <DBCheckBoxComment
                         noteId={this.props.noteId}
                         entity='PTOBJECTIVEPEDS'
                         entityKeyColumn='OPNO'
                         entityKeyValue={this.props.opno}
                         field= 'OPGAKNEE'
                         className={styles.checkbox}
                         label='Knee extensor thrust'
                         textAreaStyle={styles.formTextArea}
                       />
                    </div>
                  </div>

                  <div className={styles.form_row}>
                      <div className={styles.gap}>
                        <DBCheckBoxComment
                         noteId={this.props.noteId}
                         entity='PTOBJECTIVEPEDS'
                         entityKeyColumn='OPNO'
                         entityKeyValue={this.props.opno}
                         field= 'OPGATREND'
                         className={styles.checkbox}
                         label='Trendelenburg'
                         textAreaStyle={styles.formTextArea}
                       />
                    </div>
                  </div>

                  <div className={styles.form_row}>
                      <div className={styles.gap}>
                        <DBCheckBoxComment
                         noteId={this.props.noteId}
                         entity='PTOBJECTIVEPEDS'
                         entityKeyColumn='OPNO'
                         entityKeyValue={this.props.opno}
                         field= 'OPGATRENDCOMP'
                         checkboxStyle={styles.checkbox_size}
                         label='Trendelenburg compensation'
                         textAreaStyle={styles.formTextArea}
                       />
                    </div>
                  </div>

                  <div className={styles.form_row}>
                      <div className={styles.gap}>
                        <DBCheckBoxComment
                         noteId={this.props.noteId}
                         entity='PTOBJECTIVEPEDS'
                         entityKeyColumn='OPNO'
                         entityKeyValue={this.props.opno}
                         field= 'OPGAFOOT'
                         className={styles.checkbox}
                         label='Foot slap'
                         textAreaStyle={styles.formTextArea}
                       />
                    </div>
                  </div>

                  <div className={styles.form_row}>
                      <div className={styles.gap}>
                        <DBCheckBoxComment
                         noteId={this.props.noteId}
                         entity='PTOBJECTIVEPEDS'
                         entityKeyColumn='OPNO'
                         entityKeyValue={this.props.opno}
                         field= 'OPGADECSTEP'
                         className={styles.checkbox}
                         label='Decreased step length (L/R)'
                         textAreaStyle={styles.formTextArea}
                       />
                    </div>
                  </div>

                  <div className={styles.form_row}>
                      <div className={styles.gap}>
                        <DBCheckBoxComment
                         noteId={this.props.noteId}
                         entity='PTOBJECTIVEPEDS'
                         entityKeyColumn='OPNO'
                         entityKeyValue={this.props.opno}
                         field= 'OPGADECSTANCE'
                         className={styles.checkbox}
                         label='Decreases stance (L/R)'
                         textAreaStyle={styles.formTextArea}
                       />
                    </div>
                  </div>

                  <div className={styles.form_row}>
                      <div className={styles.gap}>
                        <DBCheckBoxComment
                         noteId={this.props.noteId}
                         entity='PTOBJECTIVEPEDS'
                         entityKeyColumn='OPNO'
                         entityKeyValue={this.props.opno}
                         field= 'OPGAINCDOUBLE'
                         checkboxStyle={styles.checkbox_size}
                         label='Increased double leg stance time'
                         textAreaStyle={styles.formTextArea}
                       />
                    </div>
                  </div>

                  <div className={styles.form_row}>
                      <div className={styles.gap}>
                        <DBCheckBoxComment
                         noteId={this.props.noteId}
                         entity='PTOBJECTIVEPEDS'
                         entityKeyColumn='OPNO'
                         entityKeyValue={this.props.opno}
                         field= 'OPGAOTHER'
                         className={styles.checkbox}
                         label='Other'
                         textAreaStyle={styles.formTextArea}
                       />
                    </div>
                  </div>

    
                </PatientCareCenterNoteSection>
            );
       
    }

}

function mapStateToProps(state) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let noteType = parseInt(noteId.split("_")[0]);
    let pk = parseInt(noteId.split("_")[1]);
    let opno = parseInt(Object.keys(state.entities.notes.PTOBJECTIVEPEDS)
        .find(key => (state.entities.notes.PTOBJECTIVEPEDS[key].OPEVNO === pk && noteType === 1)
            || (state.entities.notes.PTOBJECTIVEPEDS[key].OPNTNO === pk && noteType !== 1)));
    return {
        noteId: noteId,
        opno: opno
    };
}

const connectedPatientCareCenterNoteObjectiveObsGaitPeds = connect(mapStateToProps)(PatientCareCenterNoteObjectiveObsGaitPeds);
export { connectedPatientCareCenterNoteObjectiveObsGaitPeds as PatientCareCenterNoteObjectiveObsGaitPeds };

